/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_BeautyInputs */

const he_home_category_beauty = /** @type {(inputs: Home_Category_BeautyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביוטי ובשמים`)
};

const en_home_category_beauty = /** @type {(inputs: Home_Category_BeautyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beauty & Fragrance`)
};

/**
* | output |
* | --- |
* | "Beauty & Fragrance" |
*
* @param {Home_Category_BeautyInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_beauty = /** @type {((inputs?: Home_Category_BeautyInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_BeautyInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_beauty(inputs)
	return en_home_category_beauty(inputs)
});